export default "__VITE_ASSET__2e55b100__"